<template>
  <tr class="datagrid__row">
    <td
      v-for="([, { value: columnName, type }], index) in Object.entries(
        headers
      )"
      :key="`${index}_${columnName}`"
      :class="{
        'datagrid__cell--primary': columnName === 'avgInPeriod',
        'datagrid__cell--value': columnName != 'category'
      }"
      class="datagrid__cell "
    >
      <slot
        v-if="customColumnTypes.includes(type)"
        :column-name="columnName"
        :item="item"
      />
      <span
        v-else-if="columnName === 'name'"
        v-html="getRowName(item.name, item.subname)"
      ></span>
      <div
        v-else-if="columnName !== 'actions'"
        v-html="getCellValue(item[columnName])"
      ></div>
      <ReviewsCategoriesTableActionColumn
        v-else-if="columnName === 'actions'"
        :show-reviews-list-btn="isReviewsListEnabled"
        :item="item"
        @go-to-details="$emit('go-to-details', $event)"
        @go-to-reviews-list="$emit('go-to-list', $event)"
      />
    </td>
  </tr>
</template>

<script>
import ReviewsCategoriesTableActionColumn from "./ReviewsCategoriesTableActionColumn.vue";
export default {
  name: "ReviewsCategoriesTableRow",
  components: {
    ReviewsCategoriesTableActionColumn
  },
  props: {
    headers: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    isRowActionAllowed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customColumnTypes: ["standard", "colorTriad", "colorScale"]
    };
  },
  computed: {
    isReviewsListEnabled() {
      return (
        this.$route.name === "reviews-category-details" ||
        this.isRowActionAllowed
      );
    }
  },
  methods: {
    getRowName(name, subname) {
      return `${name} ${
        subname
          ? `<br /><span class="grid-secondary-text">${subname}</span>`
          : ""
      }`;
    },
    formatValue(value) {
      return value > 0 ? this.$options.filters.formatNumber(value) : "-";
    },
    getCellValue(value) {
      if (!Array.isArray(value)) {
        return this.formatValue(value);
      }

      const [firstValue, secondValue] = value;
      const firstFormattedValue = this.formatValue(firstValue);
      const secondFormattedValue =
        secondValue !== null ? this.formatValue(secondValue) : "";
      const textClass = secondValue !== null ? "text-primary" : "";

      return `
        <div class="${textClass}">${firstFormattedValue}</div>
        <div class="mt-2">${secondFormattedValue}</div>
      `;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .text-primary {
  color: $primary;
}
::v-deep .grid-secondary-text {
  @include font-size(14px);
  color: $gray;
}
</style>
